import api from './request'

export function contactUs (data) {
  return api({
    url: '/email',
    method: 'post',
    data
  })
}
